/*****************************Menu************************************/
$(".header-simple-menu").parent(".site-nav--has-dropdown").addClass("simple-menu_nav");
$(".header_grand_icon").click(function() {
   $(this).siblings(".site-nav__child-link--parent").siblings(".header_grand_menu").toggle(); 
});
$(".header_grand_icon").parent(".sub-grand-menu").addClass("menu-drop-icon");

  
/********************************/

$(".section-1").addClass("home-col_text-left");
$(".section-2").addClass("home-col_text-right");
$(".section-3").addClass("home-col_text-left_botm");
$(".section-4").addClass("home-col_text-right_btm");

$(".header_search_2").click(function(){
    $("#SearchDrawer").css("display", "block");
});
$(".home_style_2 .search-bar__table .search-bar__close").click(function(){
    $("#SearchDrawer").css("display", "none");
});

/*************************Tab**************************/
 $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });


var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
       // $(".accordion").removeClass("active");
    //$(".panel").removeAttr("style");
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

$(".collection-filter-mobile").click(function(){
    $(".col_list-filter").toggle();
});

/**********************Newsletter Popup***********************************/

 var id = '#dialog';
  //Get the screen height and width
  var maskHeight = $(document).height();
  var maskWidth = $(window).width();
  //Set heigth and width to mask to fill up the whole screen
  $('#mask').css({'width':maskWidth,'height':maskHeight});
  //transition effect		
  $('#mask').fadeIn(500);	
  $('#mask').fadeTo("slow",0.6);	
  //Get the window height and width
  var winH = $(window).height();
  var winW = $(window).width();
  //Set the popup window to center
  $(id).css('top',  winH/2-$(id).height()/2);
  $(id).css('left', winW/2-$(id).width()/2);
  //transition effect
  $(id).fadeIn(2000); 	
  //if close button is clicked
  $('.window .close').click(function (e) {
    //Cancel the link behavior
    e.preventDefault();
    $('#mask').hide();
    $('.window').hide();
  });		
  //if mask is clicked
  $('#mask').click(function () {
    $(this).hide();
    $('.window').hide();
  });

$(".after-login").hover(function(){
 $(".sub_child_top").toggle();
});


$(window).scroll(function(){
  var sticky_header = $(".top_header").height();
    if ($(window).scrollTop() >= sticky_header) {
       $('.top_header').addClass('fixed-header');
    }
    else {
       $('.top_header').removeClass('fixed-header');
    }
});